export default __webpack_public_path__ + "static/media/arrow2.38c529be.png";